import React from 'react';

function Check ({ text }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          width: '15px',
          height: '15px',
          border: 'solid #333 1px',
          marginRight: '5px'
        }}
      />
      <span>{text}</span>
    </div>
  );
}

export default Check;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Imuno/Impressao/Table/Check/index.js